import React from 'react'
import ConfirmationIcon from '../../assets/images/Talleres/icon_confirmacion.svg'
import styles from './done.module.scss'

export default function Done() {
  return <ConfirmationIcon className={styles.confirmation_icon} />
}
